<script setup lang="ts">
import AnalyticsCardShell from './AnalyticsCardShell.vue';
import type { AnalyticsBarRow } from './analyticsUtils';
import { formatInt } from './analyticsUtils';

defineProps<{
    title: string;
    description: string;
    metaLabel: string;
    rows: AnalyticsBarRow[];
    footnote: string;
}>();
</script>

<template>
    <AnalyticsCardShell :title="title" :description="description">
        <template #meta>
            <span
                class="shrink-0 text-xs font-medium text-muted-foreground tabular-nums"
            >
                {{ metaLabel }}
            </span>
        </template>

        <p v-if="!rows.length" class="py-2.5 text-sm text-muted-foreground">
            No tool runs over this period.
        </p>

        <div v-else class="flex flex-col">
            <div
                v-for="row in rows"
                :key="row.label"
                class="flex flex-col gap-1.5 py-2.5"
            >
                <div
                    class="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1"
                >
                    <span class="min-w-0 text-sm font-semibold">
                        {{ row.label }}
                    </span>
                    <span class="flex shrink-0 items-baseline gap-2">
                        <span
                            class="text-[13px] text-muted-foreground tabular-nums"
                        >
                            {{ formatInt(row.count) }}
                        </span>
                        <span
                            class="min-w-[38px] text-right text-sm font-bold tabular-nums"
                        >
                            {{ row.pct }}%
                        </span>
                    </span>
                </div>
                <!-- A bar per family rather than a stacked one: a message can use several
                     families, so the parts add up to more than the whole. -->
                <div class="h-1.5 overflow-hidden rounded-full bg-grey20">
                    <div
                        class="h-full rounded-full bg-primary"
                        :style="{ width: row.width + '%' }"
                    />
                </div>
            </div>
        </div>

        <div
            class="mt-auto rounded-xl bg-grey20 px-3.5 py-3 text-[13px] text-muted-foreground"
        >
            {{ footnote }}
        </div>
    </AnalyticsCardShell>
</template>
